export default "__VITE_ASSET__DitDGPK___"